module.exports = __webpack_public_path__ + "img/driveway.26b1c492.webp";